import { createAsyncThunk } from '@reduxjs/toolkit'
import Media from './media-model'
import { delete_media, load_medias, store_media } from './media-service'

export const LoadMediasAsync = createAsyncThunk<any, any>(
  'composer/load/media',
  async (params: { uid: string }) => {
    return await load_medias(params)
  },
)

export const CreateMediaAsync = createAsyncThunk<any, any>(
  'composer/create/media',
  async (params: Media) => {
    return await store_media(params)
  },
)

export const DeleteMediaAsync = createAsyncThunk<any, any>(
  'composer/delete/media',
  async (params) => {
    return await delete_media(params)
  },
)
